module.exports = __webpack_public_path__ + "img/left_layout_icon.6aa518c9.svg";